// @flow
import React, { Fragment, type Node, useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import PlainConfirmModal from 'app/common/ui-next/plain-confirm-modal';
import Person from 'app/common/classes/person';

import removeFromFoodErrorProcessing from './removeFromFoodErrorProcessing';
import useOrderSalesSubmit from '../useOrderSalesSubmit';


const emptySales = new Map([]);

type Props = {
  children: (() => void) => Node,
  customer: Person,
  orderRequestId: string,
  changeId: string,
  onRemoveFromFoodSuccess: () => void | Promise<void>
}

const RemoveFromFoodModal = ({
  children,
  customer,
  orderRequestId,
  changeId,
  onRemoveFromFoodSuccess,
}: Props): Node => {
  const { t } = useTranslation('cafeteria');
  const { id: customerId } = customer;
  const whom = customer.kogoChego.first;
  const whomAccusative = customer.kogoChto.first;
  const successMessage = t('order_request_sales_remove_from_food_success_message', { whom });

  const [displayed, setDisplayed] = useState();
  const toggleModal = useCallback(() => {
    setDisplayed(state => !state);
  }, []);

  const errorProcessing = useMemo(() => (
    removeFromFoodErrorProcessing(whomAccusative)
  ), [whomAccusative]);

  const [orderSubmit, sending] = useOrderSalesSubmit({
    orderId: orderRequestId,
    changeId,
    customerId,
    orderItemsMap: emptySales,
    onSuccess: onRemoveFromFoodSuccess,
    successMessage,
    errorProcessing,
  });

  const confirmButtonProps = useMemo(() => ({
    disabled: sending,
  }), [sending]);

  return (
    <Fragment>
      {children(toggleModal)}
      {displayed
        && <PlainConfirmModal
          confirmButtonTitle={
            sending
              ? t('order_request_sales_remove_from_food_confirm_bt_pending', 'Снятие...')
              : t('order_request_sales_remove_from_food_confirm_bt', 'Снять')
          }
          cancelButtonTitle={t('order_request_sales_remove_from_food_reject_bt', 'Отмена')}
          messageText={t('order_request_sales_remove_from_food_message', { whom: whomAccusative })}
          confirmButtonProps={confirmButtonProps}
          onCancel={toggleModal}
          onConfirm={orderSubmit}
          critical
        />}
    </Fragment>
  );
};

export default RemoveFromFoodModal;
